<template>
  <div class="container pathways__subcomponent">
    <div class="columns is-centered">
      <div class="column is-10-tablet is-8-desktop">
        <p class="title is-3 pathways-question__indicator">Question 10</p>
        <h2 class="title is-1">Have you ever used any drug by injection?</h2>
      </div>
    </div>
    <div class="columns is-centered is-multiline is-stacked">
      <div class="column is-8-tablet is-half-desktop">
        <PathwaysOption label-text="No, never">
          <input
            type="radio"
            name="never"
            value="never"
            v-model="injection"
            @change="setNextDisabled(false)"
          />
        </PathwaysOption>
      </div>
      <div class="column is-8-tablet is-half-desktop">
        <PathwaysOption label-text="Once weekly or less, or fewer than three days in a row">
          <input
            type="radio"
            name="sometimes"
            value="sometimes"
            v-model="injection"
            @change="setNextDisabled(false)"
          />
        </PathwaysOption>
      </div>
      <div class="column is-8-tablet is-half-desktop">
        <PathwaysOption label-text="More than once per week, or three or more days in a row">
          <input
            type="radio"
            name="regularly"
            value="regularly"
            v-model="injection"
            @change="setNextDisabled(false)"
          />
        </PathwaysOption>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import PathwaysOption from '@/components/pathways/PathwaysOption.vue';

const { mapActions } = createNamespacedHelpers('pathways');

export default {
  name: 'PathwaysQuestionSelfInjection',
  components: { PathwaysOption },
  computed: {
    injection: {
      get() {
        return this.$store.state.pathways.responses.injection;
      },
      set(value) {
        this.$store.dispatch('pathways/updateResponses', { injection: value });
      },
    },
  },
  mounted() {
    this.setNextDisabled(!this.injection);
  },
  methods: {
    ...mapActions({
      setNextDisabled: 'disableNext',
    }),
  },
};
</script>
